import $ from 'jquery';
import AjaxForm from '@shopify/marketing-assets/javascripts/modules/ajax-form';
import Analytics from '@shopify/marketing-assets/javascripts/global/analytics';
import {track as trackFacebookPixelEvent} from '../utilities/facebook-pixel';

function initializeOfferForm() {
  const $form = $('.js-offer-form');
  const gaCategory = $form.data('ga-category');
  const gaAction = $form.data('ga-action');
  const fbqEvent = $form.data('fbq-event');

  const AVERAGE_OFFERS_BEFORE_ACCEPTING = 0.25;
  const COMMISSION = 0.11;
  const GMV = 1200;

  if ($form.length) {
    new AjaxForm($form, [], {
      onSuccess() {
        const formData = this.$form.serializeJSON();
        const offerValue = formData['offer[amount]'];
        const gaValue =
          Math.round((offerValue * AVERAGE_OFFERS_BEFORE_ACCEPTING * COMMISSION) +
            (AVERAGE_OFFERS_BEFORE_ACCEPTING * GMV));

        Analytics.track(gaCategory, gaAction, null, gaValue);
        trackFacebookPixelEvent(fbqEvent);
      },
      onError(errors) {
        if (errors) {
          displayError($form, errors);
        }
      },
    });
  }
}

function displayError($form, errors) {
  Object.entries(errors).forEach((keyEntryPair) => {
    const entry = keyEntryPair[1];
    const errorFieldName = Object.keys(entry)[0];
    const errorFieldValue = entry[errorFieldName][0];

    const errorContainer = $form.find(`input[name="offer[${errorFieldName}]"]`)
      .parents('.marketing-input-wrapper')
      .find('.marketing-form__messages');
    errorContainer.prepend($('<span class="error"/>').text(errorFieldValue));
  });
  // Hide global generic error added by MA
  $form.find('.marketing-form__messages').last().hide();
}


export default initializeOfferForm;
